import { useAtomValue } from "jotai";
import { AIMContextViewAtom } from "./context.state";
import { DeltaLineagePanel } from "../DeltaLineagePanel";
import { InvestmentCriteriaDrawer } from "../InvestementCriteriaDrawer";
import { FinanceLabLineagePanel } from "../FinanceLabLineagePanel";
import { DataSourcesPanel } from "../DataSourcesPanel";
import { AIMViewType } from "./AIMContext.types";
import { MetricLineagePanel } from "../MetricLineagePanel/MetricLineagePanel";
import { LTMLineagePanel } from "../LTMLineagePanel";
import { EvaluatedCtxLineagePanel } from "../EvaluatedCtxLineagePanel";
import { EmptyMetricPanel } from "../EmptyMetricPanel";

export function AIMPanelContainer() {
    const AIMContextView = useAtomValue(AIMContextViewAtom);

    if (AIMContextView?.type === AIMViewType.DATA_SOURCES_SETTINGS) {
        return <DataSourcesPanel />;
    }

    if (AIMContextView?.type === AIMViewType.DELTA_LINEAGE) {
        return <DeltaLineagePanel {...AIMContextView.props} />;
    }

    if (AIMContextView?.type === AIMViewType.INVESTMENT_CRITERIA) {
        return <InvestmentCriteriaDrawer />;
    }

    if (AIMContextView?.type === AIMViewType.LABS_LINEAGE) {
        return <FinanceLabLineagePanel {...AIMContextView} />;
    }

    if (AIMContextView?.type === AIMViewType.METRIC_LINEAGE) {
        return <MetricLineagePanel {...AIMContextView.props} />;
    }

    if (AIMContextView?.type === AIMViewType.LTM_LINEAGE) {
        return <LTMLineagePanel {...AIMContextView.props} />;
    }

    if (AIMContextView?.type === AIMViewType.EVALUATED_CTX_LINEAGE) {
        return <EvaluatedCtxLineagePanel {...AIMContextView.props} />;
    }

    if (AIMContextView?.type === AIMViewType.EMPTY_METRIC) {
        return <EmptyMetricPanel {...AIMContextView.props} />;
    }

    return null;
}
